import i18n from '@/locales';
import { createApp } from 'vue';
import ProjectRentalBrowsing from '@/components/rental/ProjectRentalBrowsing.vue';

const app = createApp({});
app.use(i18n);
app.component('ProjectRentalBrowsing', ProjectRentalBrowsing);
app.mount('#projectRentalBrowsingApp');
